import login from "./locales/en/features/login.json";
import redirect from "./locales/en/features/redirect.json";
import resetPassword from "./locales/en/features/reset-password.json";
import locationSelector from "./locales/en/ui/location-selector.json";
import warehouse from "./locales/en/features/warehouse.json";
import pallet from "./locales/en/features/pallet.json";
import portal from "./locales/en/features/portal.json";
import analytics from "./locales/en/features/analytics.json";
import outbound from "./locales/en/features/outbound.json";

export const TRANSLATION_NAMESPACE = {
  // FEATURES
  login: "features.login",
  redirect: "features.redirect",
  resetPassword: "features.resetPassword",
  locationSelector: "ui.locationSelector",
  warehouse: "features.warehouse",
  pallet: "features.pallet",
  portal: "features.portal",
  analytics: "features.analytics",
  outbound: "features.outbound",
} as const;

export const TRANSLATIONS = {
  en: {
    // FEATURES
    [TRANSLATION_NAMESPACE.login]: login,
    [TRANSLATION_NAMESPACE.redirect]: redirect,
    [TRANSLATION_NAMESPACE.resetPassword]: resetPassword,
    [TRANSLATION_NAMESPACE.locationSelector]: locationSelector,
    [TRANSLATION_NAMESPACE.warehouse]: warehouse,
    [TRANSLATION_NAMESPACE.pallet]: pallet,
    [TRANSLATION_NAMESPACE.portal]: portal,
    [TRANSLATION_NAMESPACE.analytics]: analytics,
    [TRANSLATION_NAMESPACE.outbound]: outbound,
  },
} as const;
